import i18n from "@/i18n";
import { del, get, post } from "@/requests/server";

export async function addTrustedBorrower(loanableId, userId) {
  await post(
    `/loanables/${loanableId}/roles`,
    {
      user_id: userId,
      role: "trusted_borrower",
    },
    {
      notifications: {
        action: i18n.t(
          "requests.loanable_user_roles_requests.notifications.add_trusted_borrower.action"
        ),
        onSuccess: i18n.t(
          "requests.loanable_user_roles_requests.notifications.add_trusted_borrower.success"
        ),
      },
    }
  );
}

export async function removeTrustedBorrower(trustedBorrower) {
  if (!trustedBorrower) {
    return;
  }

  await del(`/loanables/roles/${trustedBorrower.id}`, {
    notifications: {
      action: i18n.t(
        "requests.loanable_user_roles_requests.notifications.remove_trusted_borrower.action"
      ),
      onSuccess: i18n.t(
        "requests.loanable_user_roles_requests.notifications.remove_trusted_borrower.success"
      ),
    },
  });
}

export async function searchUsersAssignableToRole(loanableId, role, q, params = {}) {
  const { data } = await get(`/loanables/${loanableId}/usersAssignableToRole`, {
    axiosRequestConfig: {
      params: {
        ...params,
        role,
        q,
      },
    },
    notifications: { action: i18n.t("store.rest_module.notifications.search.action") },
  });

  return data;
}
